import { gql } from '@apollo/client'

export const NOTIFICATIONS_SUBSCRIPTION = gql`
  subscription ($user_id: String!) {
    notificationsSubscription(user_id: $user_id) {
      user_id
    }
  }
`
